import React, { createContext, useContext, useState, useCallback } from "react";
import {
  deriveAccounts, encryptVault, decryptVault, hasVault, clearVault, generateMnemonic, validateMnemonic,
} from "../lib/wallet";

const WalletCtx = createContext(null);
export const useWallet = () => useContext(WalletCtx);

export function WalletProvider({ children }) {
  const [accounts, setAccounts] = useState(null); // null = locked / no wallet
  const [walletExists, setWalletExists] = useState(hasVault());
  const [draftMnemonic, setDraftMnemonic] = useState("");

  const newDraft = useCallback((words = 12) => {
    const m = generateMnemonic(words);
    setDraftMnemonic(m);
    return m;
  }, []);

  const commitWallet = useCallback((mnemonic, pin, words) => {
    const acc = deriveAccounts(mnemonic);
    encryptVault(mnemonic, pin, words);
    setAccounts(acc);
    setWalletExists(true);
    setDraftMnemonic("");
    return acc;
  }, []);

  const unlock = useCallback((pin) => {
    const mnemonic = decryptVault(pin);
    if (!mnemonic) return false;
    setAccounts(deriveAccounts(mnemonic));
    return true;
  }, []);

  const lock = useCallback(() => setAccounts(null), []);

  const reset = useCallback(() => {
    clearVault();
    setAccounts(null);
    setWalletExists(false);
    setDraftMnemonic("");
  }, []);

  const value = {
    accounts,
    walletExists,
    isUnlocked: !!accounts,
    draftMnemonic,
    newDraft,
    setDraftMnemonic,
    commitWallet,
    unlock,
    lock,
    reset,
    validateMnemonic,
  };
  return <WalletCtx.Provider value={value}>{children}</WalletCtx.Provider>;
}
